"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _card_component = require("./global_components/card_component");

var _card_component2 = _interopRequireDefault(_card_component);

var _number_utility = require("common-utilities/src/number_utility");

var _number_utility2 = _interopRequireDefault(_number_utility);

var _formatted_number = require("./global_components/formatted_number");

var _formatted_number2 = _interopRequireDefault(_formatted_number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundCarbonEmissions = function (_PureComponent) {
  _inherits(FundCarbonEmissions, _PureComponent);

  function FundCarbonEmissions() {
    _classCallCheck(this, FundCarbonEmissions);

    return _possibleConstructorReturn(this, (FundCarbonEmissions.__proto__ || Object.getPrototypeOf(FundCarbonEmissions)).apply(this, arguments));
  }

  _createClass(FundCarbonEmissions, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _card_component2.default,
          {
            className: "print-full-width",
            dataTest: "fund-carbon-emission",
            headerTitle: _react2.default.createElement(_reactIntl.FormattedMessage, { id: "pdp-fund-carbon-emission-header", defaultMessage: "Carbon Intensity" }),
            headerTitleId: "fund-carbon-emissions-id",
            headerTitleLabel: "",
            headerLabel: "",
            displayStyle: 'width-percent-100',
            breakpoint: this.props.breakpoint,
            disclosureText: this.props.disclosure,
            placementId: "pdpCardCarbonEmission"
          },
          _react2.default.createElement(
            "div",
            { "data-testid": "fund-carbon-emissions-data" },
            _react2.default.createElement(
              "div",
              { className: "row margin-all-0 padding-vertical-5" },
              _react2.default.createElement(
                "div",
                { className: "col-md-12 col-lg-12 col-xlg-12 padding-left-0 padding-right-0" },
                _react2.default.createElement(
                  "span",
                  { "data-testid": "fund-carbon-emission-sub-header-1", className: "text-left col-xs-6 col-sm-6 col-md-5 col-lg-5 col-xlg-5 font-light caption" },
                  " ",
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "pdp-fund-carbon-emission-sub-header-1", defaultMessage: "Weighted Average Carbon Intensity" })
                ),
                _react2.default.createElement(
                  "span",
                  { "data-testid": "fund-carbon-emission-sub-header-val-1", className: "text-right col-xs-6 col-sm-6 col-md-7 col-lg-7 col-xlg-7 float-right font-light caption" },
                  _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertToNDecimalFixedNumber(this.props.fundCarbonEmission.weightedAverageCarbonIntensityValue, 2), this.props.numberFormat),
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "pdp-fund-carbon-emission-sub-header-1-unit", defaultMessage: " tons CO2e/$M sales" })
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "row margin-all-0 padding-vertical-5" },
              _react2.default.createElement(
                "div",
                { className: "col-md-12 col-lg-12 col-xlg-12 padding-left-0 padding-right-0" },
                _react2.default.createElement(
                  "span",
                  { "data-testid": "fund-carbon-emission-sub-header-2", className: "text-left col-xs-6 col-sm-6 col-md-5 col-lg-5 col-xlg-5 font-light caption" },
                  " ",
                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: "pdp-fund-carbon-emission-sub-header-2", defaultMessage: "Sub Fund Portfolio Weight" })
                ),
                _react2.default.createElement(
                  "span",
                  { "data-testid": "fund-carbon-emission-sub-header-val-2", className: "text-right col-xs-6 col-sm-6 col-md-7 col-lg-7 col-xlg-7 float-right font-light caption" },
                  _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.fundCarbonEmission.coveragebyportfolioWeightPercentage), this.props.numberFormat)
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FundCarbonEmissions;
}(_react.PureComponent);

exports.default = FundCarbonEmissions;